import React from 'react';
import {globalUpdate} from "./AppRouter";
import api from "./api";
import auth from "./auth";

let translations: any = {};

let bulkLoaded = false;
let bulkLoading = false;

const implodeParams = (key: any, ...params: any[]) => {
    let i = 0;
    for (let param of params) {
        key = key?key.replace("%"+i, param):key
    }
    return key
}


const startEditTranslation = (key: any, txt: any) => {
    let tr = prompt("edit translation \"" + key + "\"", txt)
    api.post("translations/update", { key: key, translation: tr}).ok((msg) => {
        translations[msg.data.key] = msg.data.translation;
        globalUpdate()
    })
}

let _trUpdateEnable = false;
export const trUpdateEnable = (enable?: boolean) => {
    if (enable !== undefined) {
        _trUpdateEnable = enable
    }
    return _trUpdateEnable
}



const megaT = (key: any, txt: any) => {
    if (auth.can("translator") && trUpdateEnable()) {
        return <>
                {txt}&nbsp;
                <i className="fa fa-edit" onClick={(e) => {
                    e.preventDefault()
                    startEditTranslation(key, txt)
                }}></i>
            </>
    } else {
        return txt;
    }
}

export const translationsBulkLoad = () => {
    api.get("translations/bulk").ok((msg) => {
        translations = msg.data
        bulkLoaded = true
        bulkLoading = false
        globalUpdate()
    }).error(() => {
        bulkLoaded = true
        bulkLoading = false
    })
}

export const t = (key: any, ...params: any[]) => {
    if (!key) return key;
    if (!bulkLoaded && !bulkLoading) {
        bulkLoading = true;
        translationsBulkLoad()
    } else if (bulkLoaded && !translations[key]) {
        api.post("translations/miss", { key: key }).ok((msg) => {
            translations[key] = msg.data
            //globalPendedUpdate()
        }).error(() => {
            translations[key] = key
        })
        return megaT(key, implodeParams(key, ...params))
    }
    return megaT(key, implodeParams(translations[key], ...params))
}

